// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
//import {BackgroundImage} from 'components/Image';
import {LayoutWrapper} from 'components/Layout';
import {useLocalized} from 'components/Localized';
import Logo from 'components/Logo'
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer';
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';
import ButtonNextPage from 'components/ButtonNextPage';

type Props = {
  nextPath?: string,
}

export default function Tutorial(props: Props): React.Element<any> {
  const history = useHistory();
  const localized = useLocalized();
  React.useEffect(()=>{
    VideoUtils.loadTutorialBG();
    VideoUtils.play();
    AudioUtils.playBGM_UI();
    return ()=>{
      VideoUtils.unload();
    };
  }, []);
  React.useEffect(()=>{
    window.tagManager.welcomePage();
  },[]);

  
  return (
    <main>
      <Wrapper>
        <Contents>
          <DivTitle>
            <LocalizedParagraphWithMargin {...localized.tutorial_p01_welcome_001} >
            {localized.tutorial_p01_welcome_001.datatext}
            </LocalizedParagraphWithMargin>
          </DivTitle>
          <div>
          <LocalizedParagraphWithMargin {...localized.tutorial_p01_welcome_002}>
          {localized.tutorial_p01_welcome_002.datatext}
          </LocalizedParagraphWithMargin>
          </div>
          <DivBottom />
        </Contents>
      </Wrapper>
      <ButtonNextPage
        title={localized.tutorial_p01_welcome_003}
        onNext={() => {
          history.push(props.nextPath); 
          window.tagManager.indexNextLinkClick();
        } }
      />
      <Logo />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const Wrapper = styled(LayoutWrapper)`

  text-align: center;
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LocalizedParagraphWithMargin = styled.p`
  margin-left: ${(props) => (props.theme.layout.mobile ? 20 : 30)}px;
  margin-right: ${(props) => (props.theme.layout.mobile ? 20 : 30)}px;

  color: ${(props) => props.datacolor};
  font-family: ${(props) => props.datafont};
  font-size: ${(props) => props.datasize * (props.theme.layout.scale ?? 1)}px;
  line-height: ${(props) => props.datalineheight * (props.theme.layout.scale ?? 1)}px;
  letter-spacing: ${(props) => props.dataletterspacing > 0 ? `${props.dataletterspacing}px` : undefined};
  text-shadow: ${(props) => props.datatextshadowr > 0 ? `${props.datatextshadowx}px ${props.datatextshadowy}px ${props.datatextshadowr}px ${props.datatextshadowc}` : undefined};
  text-align: ${props => props.datatextalign};
  white-space: pre-line;
`;

const Contents = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

const DivTitle = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DivBottom = styled.div`
  flex: 1;
`;
